import React from "react";
import { Helmet } from "react-helmet";
import HeroSlider from "../components/HeroSlider";
import ContactForm from '../components/ContactForm'
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const About = () => {
  const {t} = useTranslation();

  const services = [
    { title: t('home.ticketDefense'), className: "ticket", to: '/services/ticket' },
    { title: t('home.notaryServices'), className: "notary", to: '/services/notary' },
    { title: t('home.recordSuspension'), className: "pardon", to: '/services/pardon' },
    { title: t('home.legalDocumentDrafting'), className: "drafting", to: '/services/drafting' },
    { title: t('smallClaimCourt.title'), className: "small-claim", to: '/services/small-claim-court' },
    { title: t('landlordTenantDispute.title'), className: "landlord-tenant-dispute", to: '/services/landlord-tenant-dispute' },
    { title: t('home.familyLegalServices'), className: "family", to: '/services/family-legal-services' },
  ];
  return (
    <>
      <div className="home-page">
        <Helmet>
          <title>
            Min & Ying Legal Services Professional Corporation
          </title>
          
          <meta
            name="description"
            content="Min & Ying Legal Services Professional Corporation"
          />
        </Helmet>

        <HeroSlider/>

        <div className="container-fluid container">
          <div className="row gap-6 p-5 mobile-padding align-items-center">
            <div className="col-12 mb-5">
              <h5 className="guide-text font-weight-bold mb-3">{t('home.title')}</h5>
              <div style={{ textAlign: 'justify' }}>{t('home.homeIntro')}</div>
            </div>
            <section className="container py-5 mb-5">
            <div className="text-center mb-5">
              <h2 className="fw-bold">{t('home.ourServices')}</h2>
              <p className="text-muted">{t('home.ourServicesSubtitle')}</p>
            </div>
            <div className="row g-4" style={{justifyContent: 'center'}}>
                {services.map((service, index) => (
                      <div className="col-md-6 col-lg-3" key={index}>
                        <Link to={service.to} class="text-decoration-none">
                          <div className={`service-card ${service.className} position-relative rounded overflow-hidden`} style={{ height: "250px", backgroundSize: "cover", backgroundPosition: "center" }}>
                            <div className="overlay-gradient position-absolute top-0 start-0 w-100 h-100"></div>
                            <div className="position-absolute bottom-0 start-0 w-100 p-3 text-white">
                              <h5 className="mb-0">{service.title}</h5>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
              </div>
            </section>
            <div className="col-12 bg-light rounded mx-auto condensed-contact-form">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
